import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Subcategory} from '../models/subcategory';
import {map, Observable} from 'rxjs';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Subcategory>;
  private item: Observable<Subcategory>;

  constructor (private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref.orderBy('name', 'asc'))
      .get()
  }

  loadAll () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .orderBy('name', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
          } as Subcategory;
        }))
      );
  }


  selectSubcategories (isPartner: boolean) {
    //   return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .where('partner', '==', isPartner)
      .orderBy("name")).snapshotChanges();
  }

  selectAnnuityCategories () {
    //   return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .where('annuity', '==', true)
      .orderBy("name")).snapshotChanges();
  }

  async selectPartners () {
    const array = [];
    const querySnapshot = await this.db.collection('sbccv_subcategories', ref => ref
      .where('partner', '==', true)
      .orderBy("name"))
      .get()
      .toPromise();

    querySnapshot.forEach(async (doc: any) => {
      array.push({
        "id": doc.id,
        "name": doc.data().name
      })
    })

    return array;

  }

  selectById (id) {
    this.itemDoc = this.db.doc<Subcategory>('sbccv_subcategories/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert (entity: Subcategory) {
    delete entity.id;
    return this.db.collection('sbccv_subcategories').add(Object.assign({}, entity));
  }

  update (entity: Subcategory) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_subcategories').doc(id).set(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_subcategories').doc(entity_id).delete();
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }

    return msgError
  }


  selectSubCategoriesWithAnnuites () {
    return this.db.collection<Subcategory>('sbccv_subcategories', ref => ref
      .where('annuity', '==', true)
      .orderBy("name")).get();
  }

}
